import React from 'react';
import { connect } from 'react-redux';
import {
  redirectToResults as redirectToResultsAction,
  showStructurePopup as showStructurePopupAction,
  copyQuery as copyQueryAction,
  createAlert as createAlertAction,
} from '@Pages/QuickSearch/Components/QuickResults/QuickResultsActions';
import { previewItems as previewItemsSelector, resultsMap as resultsMapSelector } from './selectors';
import { showMoreResults as showMoreResultsAction } from './actions';
import { ResultsMap } from './contexts';
import ResultsPreview from './ResultsPreview';

function ResultsPreviewContainer(props) {
  // eslint-disable-next-line react/prop-types
  const { resultsMap } = props;
  return (
    <ResultsMap.Provider value={resultsMap}>
      <ResultsPreview {...props} />
    </ResultsMap.Provider>
  );
}

const mapStateToProps = (state) => {
  return {
    previewItems: previewItemsSelector(state),
    resultsMap: resultsMapSelector(state),
  };
};

const mapDispatchToProps = {
  showMoreResults: showMoreResultsAction,
  showStructurePopup: showStructurePopupAction,
  copyQuery: copyQueryAction,
  createAlert: createAlertAction,
  redirectToResults: redirectToResultsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsPreviewContainer);
